// extracted by mini-css-extract-plugin
export default {"present":"FullPresent_present__MDayA"};